export const TABLE_EVENT_TYPE = {
    CLICK_CELL: "click_cell",
    DBLCLICK_CELL: "dblclick_cell",
    MOUSEDOWN_CELL: "mousedown_cell",
    MOUSEUP_CELL: "mouseup_cell",
    SELECTED_CELL: "selected_cell",
    SELECTED_CLEAR: "selected_clear",
    BEFORE_KEYDOWN: "before_keydown",
    KEYDOWN: "keydown",
    MOUSEENTER_TABLE: "mouseenter_table",
    MOUSELEAVE_TABLE: "mouseleave_table",
    MOUSEDOWN_TABLE: "mousedown_table",
    MOUSEMOVE_TABLE: "mousemove_table",
    MOUSEMOVE_CELL: "mousemove_cell",
    MOUSEENTER_CELL: "mouseenter_cell",
    MOUSELEAVE_CELL: "mouseleave_cell",
    CONTEXTMENU_CELL: "contextmenu_cell",
    CONTEXTMENU_CANVAS: "contextmenu_canvas",
    RESIZE_COLUMN: "resize_column",
    RESIZE_COLUMN_END: "resize_column_end",
    RESIZE_ROW: "resize_row",
    RESIZE_ROW_END: "resize_row_end",
    MERGE_CELLS: "merge_cells",
    UNMERGE_CELLS: "unmerge_cells",
    CHANGE_HEADER_POSITION_START: "change_header_position_start",
    CHANGE_HEADER_POSITION: "change_header_position",
    CHANGING_HEADER_POSITION: "changing_header_position",
    CHANGE_HEADER_POSITION_FAIL: "change_header_position_fail",
    SORT_CLICK: "sort_click",
    AFTER_SORT: "after_sort",
    FREEZE_CLICK: "freeze_click",
    SCROLL: "scroll",
    CAN_SCROLL: "can_scroll",
    SCROLL_HORIZONTAL_END: "scroll_horizontal_end",
    SCROLL_VERTICAL_END: "scroll_vertical_end",
    DROPDOWN_MENU_CLICK: "dropdown_menu_click",
    MOUSEOVER_CHART_SYMBOL: "mouseover_chart_symbol",
    DRAG_SELECT_END: "drag_select_end",
    SELECTED_CHANGED: "selected_changed",
    COPY_DATA: "copy_data",
    DROPDOWN_ICON_CLICK: "dropdown_icon_click",
    DROPDOWN_MENU_CLEAR: "dropdown_menu_clear",
    TREE_HIERARCHY_STATE_CHANGE: "tree_hierarchy_state_change",
    SHOW_MENU: "show_menu",
    HIDE_MENU: "hide_menu",
    ICON_CLICK: "icon_click",
    LEGEND_ITEM_CLICK: "legend_item_click",
    LEGEND_ITEM_HOVER: "legend_item_hover",
    LEGEND_ITEM_UNHOVER: "legend_item_unHover",
    LEGEND_CHANGE: "legend_change",
    MOUSEENTER_AXIS: "mouseenter_axis",
    MOUSELEAVE_AXIS: "mouseleave_axis",
    CHECKBOX_STATE_CHANGE: "checkbox_state_change",
    RADIO_STATE_CHANGE: "radio_state_change",
    SWITCH_STATE_CHANGE: "switch_state_change",
    BEFORE_SET_SIZE: "before_set_size",
    BEFORE_INIT: "before_init",
    BEFORE_UPDATE_OPTION: "before_update_option",
    AFTER_RENDER: "after_render",
    INITIALIZED: "initialized",
    UPDATED: "updated",
    AFTER_UPDATE_CELL_CONTENT_WIDTH: "after_update_cell_content_width",
    AFTER_UPDATE_SELECT_BORDER_HEIGHT: "after_update_select_border_height",
    CHANGE_CELL_VALUE: "change_cell_value",
    CHANGE_CELL_VALUES: "change_cell_values",
    DRAG_FILL_HANDLE_END: "drag_fill_handle_end",
    MOUSEDOWN_FILL_HANDLE: "mousedown_fill_handle",
    DBLCLICK_FILL_HANDLE: "dblclick_fill_handle",
    EMPTY_TIP_CLICK: "empty_tip_click",
    EMPTY_TIP_DBLCLICK: "empty_tip_dblclick",
    BUTTON_CLICK: "button_click",
    BEFORE_CACHE_CHART_IMAGE: "before_cache_chart_image",
    PASTED_DATA: "pasted_data",
    PLUGIN_EVENT: "plugin_event",
    ADD_RECORD: "add_record",
    DELETE_RECORD: "delete_record",
    UPDATE_RECORD: "update_record",
    ADD_COLUMN: "add_column",
    DELETE_COLUMN: "delete_column",
    FILTER_MENU_SHOW: "filter_menu_show",
    FILTER_MENU_HIDE: "filter_menu_hide"
};
//# sourceMappingURL=TABLE_EVENT_TYPE.js.map